import React from 'react'
import Component from '../common/Component'
import BenefitsSetBulkEditsComponent from '../BenefitsSet/BenefitsSetBulkEditsComponent'
import { benefitLabels, metadatumFieldsDiffSet } from './visionFields'

const defaultFields = {
  default: {
    values: [
      'hios_ids',
      'id',
      'vericred_id',
      'name',
      'audience',
      'plan_type',
      'issuer_name',
      'stand_alone',
      'voluntary',
      'effective_date',
      'expiration_date',
      'exam_copay',
      'materials_copay',
      'exams',
      'lenses',
      'contacts',
      'frames'
    ],
    pinned: ['id', 'vericred_id', 'sbc_url', 'sob_url']
  }
}

export default class VisionBenefitsSetBulkEditsComponent extends Component {
  render() {
    return (
      <BenefitsSetBulkEditsComponent
        benefitLabels={benefitLabels}
        metadatumFields={metadatumFieldsDiffSet}
        defaultFields={defaultFields}
        benefitsSetUrl="/vision_benefits"
        productLine="vision"
        includeSbcCheckbox
        sbcCheckboxLabel="Build from Benefit Summaries"
        hideSobUrl
        {...this.props}
      />
    )
  }
}
